import {Component, EventEmitter, forwardRef, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, inject} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SelectItem} from "primeng/api";
import {ConfiguratorDataViewService} from "@tj/tj-dmp-lib-api";
import { finalize } from 'rxjs/operators';
import {resolveI18nLabel} from '../../pipes/i18n-label.pipe';
import {LangService} from '../../services/lang.service';

@Component({
    selector: 'dmp-select-view',
    templateUrl: './select-view.component.html',
    styleUrls: ['./select-view.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SelectViewComponent),
        }
    ],
    standalone: false
})
export class SelectViewComponent implements OnInit, OnChanges, ControlValueAccessor {
  private readonly langService = inject(LangService);
  @Input() disabled = false;
  value: string = '';

  @Input() tenant: string;
  @Output() changeView = new EventEmitter<String>();

  list: SelectItem[] = [];
  touched = false;
  private isProcessing: boolean = false;
  private pendingTenant: string = null;

  constructor(
    private configuratorDataViewService: ConfiguratorDataViewService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tenant && this.tenant) {
      if (!this.isProcessing) {
        this.loadViewData();
      } else {
        this.pendingTenant = this.tenant;
      }
    }
  }

  ngOnInit(): void {
    if (this.tenant && !this.isProcessing) {
      this.loadViewData();
    }
  }

  private loadViewData(): void {
    this.isProcessing = true;
    this.configuratorDataViewService.getAllDataViewsUsingGET(this.tenant)
      .pipe(
        finalize(() => {
          this.isProcessing = false;
          if (this.pendingTenant && this.pendingTenant != this.tenant) {
            this.tenant = this.pendingTenant;
            this.pendingTenant = null;
            this.loadViewData();
          }
        })
      )
      .subscribe(
        data => {
          this.list = data.map(item => ({ label: resolveI18nLabel(item.labels, this.langService.currentLang, item.name), value: item.id } as SelectItem));
          this.handleDefaultSelection();
          this.isProcessing = false;
        },
        error => {
          this.isProcessing = false;
        }
      );
  }

  private handleDefaultSelection(): void {
    if (this.list.length === 0) {
      return;
    }

    if (this.value) {
      const valueExists = this.list.some(item => item.value === this.value);
      if (!valueExists) {
        this.value = this.list[0].value;
        this.onChange(this.value);
      }
    } else {
      this.value = this.list[0].value;
      this.onChange(this.value);
    }
  }

  writeValue(val: any): void {
    this.value = val;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  valueChange(): void {
    if (!this.value) return;

    this.changeView.emit(this.value);
    this.onChange(this.value);

    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
